import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux';
import { user } from './reducers.user.js';
import { team } from './reducers.team.js';
import { tooltip } from './reducers.tooltip.js';
import { toast } from './reducers.toast.js';
import { docs } from './reducers.docs.js';
import { patternManager } from './reducers.patternManager.js';
import { memberManager } from './reducers.memberManager.js';
import { domainManager } from './reducers.domainManager.js';
import { globalReducer } from './reducers.globalReducer.js';

import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
  routing,
  user,
  team,
  memberManager,
  domainManager,
  patternManager,
  globalReducer,
  form: formReducer,
  tooltip,
  toast,
  docs
  // ...
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/reducers.export.js